
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service/report",
      function () {
        return require("private-next-pages/service/report/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/service/report"])
      });
    }
  